import store from '@speechki-frontend/core/store/store';

import payment from '@speechki-frontend/core/payment/store';
import { initEditorStore } from '@speechki-frontend/core/editor/store';
import book, { contractors } from '@speechki-frontend/core/book/store';
import { createPagedBookpartsStore } from '@speechki-frontend/core/editor/store/bookparts';

createPagedBookpartsStore(store);

// core modules
store.registerModule('payment', payment);
store.registerModule('book', book);
store.registerModule('contractors', contractors);

initEditorStore(store);

// specific modules
// store.registerModule('someModule', module);

export default store;
